export default __webpack_public_path__ + "static/small-5-99d9564a71996be94635f5430a15e3cd.png";